import React, { useEffect, useState, useMemo } from 'react';
import './App.css';

const PERFUMES = [
  { id: 1, name: "Oud Royale", price: 210, category: "Oriental", notes: ["oud", "sandalwood", "vanille"], img: "https://dopamineshop.in/cdn/shop/files/PGP1074_copy.webp?v=1746170368&width=1080" },
  { id: 2, name: "Midnight Rose", price: 185, category: "Floral", notes: ["rose", "musc", "amber"], img: "https://tse3.mm.bing.net/th/id/OIP.naXj4vXEu0zXlaWUFmSUWQHaJ4?cb=defcache2&defcache=1&rs=1&pid=ImgDetMain&o=7&rm=3" },
  { id: 3, name: "Vanille Noir", price: 195, category: "Gourmand", notes: ["vanille", "tonka bean", "amber"], img: "https://th.bing.com/th/id/OIP.l9Jq1DATg6s0Z1eCQhASrwHaE8?w=285&h=190&c=7&r=0&o=7&cb=defcache2&dpr=1.5&pid=1.7&rm=3&defcache=1" },
  { id: 4, name: "Cedar Mist", price: 165, category: "Woody", notes: ["cedar", "bergamote", "vetiver"], img: "https://th.bing.com/th/id/OIP.oe6RfGBW0yOXEsHkm6PcvAHaHa?w=174&h=180&c=7&r=0&o=7&cb=defcache2&dpr=1.5&pid=1.7&rm=3&defcache=1" },
  { id: 5, name: "Golden Amber", price: 225, category: "Oriental", notes: ["amber", "patchouli", "saffron"], img: "https://th.bing.com/th/id/OIP.1GU5PLkdtfR9w_ehKLSdvgHaHa?w=202&h=202&c=7&r=0&o=7&cb=defcache2&dpr=1.5&pid=1.7&rm=3&defcache=1" },
  { id: 6, name: "White Musc", price: 175, category: "Clean", notes: ["musc", "white tea", "iris"], img: "https://fimgs.net/mdimg/secundar/fit.46851.jpg" },
  { id: 7, name: "Saffron Dream", price: 240, category: "Exotic", notes: ["saffron", "leather", "smoke"], img: "https://th.bing.com/th/id/OIP.hjb8Fa8jshxEaEuKQRiDxAHaLH?w=116&h=180&c=7&r=0&o=7&cb=defcache2&dpr=1.5&pid=1.7&rm=3&defcache=1" },
  { id: 8, name: "Bergamot Breeze", price: 155, category: "Citrus", notes: ["bergamote", "lemon", "mint"], img: "https://th.bing.com/th/id/OIP.KM2G9W-xItVtuBMQ2lMYyAHaJ4?w=155&h=207&c=7&r=0&o=7&cb=defcache2&dpr=1.5&pid=1.7&rm=3&defcache=1" },
  { id: 9, name: "Dark Iris", price: 200, category: "Powdery", notes: ["iris", "violet", "woods"], img: "https://th.bing.com/th/id/OIP.s0xCavHoRgTRX4olsRoufAHaGk?w=190&h=180&c=7&r=0&o=7&cb=defcache2&dpr=1.5&pid=1.7&rm=3&defcache=1" },
  { id: 10, name: "Spice Path", price: 190, category: "Spicy", notes: ["cardamom", "cinnamon", "vanille"], img: "https://th.bing.com/th/id/OIP.8L0tjGiJ4dqF1hyMUcVWVAHaHa?w=184&h=184&c=7&r=0&o=7&cb=defcache2&dpr=1.5&pid=1.7&rm=3&defcache=1" },
  { id: 11, name: "Eternal Oud", price: 280, category: "Luxury", notes: ["oud", "rose", "tobacco"], img: "https://tse2.mm.bing.net/th/id/OIP.kGMUNeZ1MjMtEyhTfqf4egHaHa?cb=defcache2&pid=ImgDet&defcache=1&w=181&h=181&c=7&dpr=1.5&o=7&rm=3" },
  { id: 12, name: "Silk Trail", price: 215, category: "Elegant", notes: ["peony", "jasmine", "musc"], img: "https://th.bing.com/th/id/OIP.CNRy41zdX4-7MfFRnCGFaQHaHa?w=169&h=180&c=7&r=0&o=7&cb=defcache2&dpr=1.5&pid=1.7&rm=3&defcache=1" },
  { id: 13, name: "Oceanic Drift", price: 160, category: "Fresh", notes: ["sea salt", "lemon", "cedar"], img: "https://th.bing.com/th/id/OIP.PuIGynOKml5PF4qK0zT7VQHaHa?w=180&h=180&c=7&r=0&o=7&cb=defcache2&dpr=1.5&pid=1.7&rm=3&defcache=1" },
  { id: 14, name: "Velvet Tabac", price: 230, category: "Oriental", notes: ["tobacco", "honey", "vanille"], img: "https://th.bing.com/th/id/OIP.EXftk0Qdvty1u9v-ybWU-wHaHa?w=198&h=198&c=7&r=0&o=7&cb=defcache2&dpr=1.5&pid=1.7&rm=3&defcache=1" },
  { id: 15, name: "Wild Jasmine", price: 180, category: "Floral", notes: ["jasmine", "neroli", "musc"], img: "https://th.bing.com/th/id/OIP.zdqY40DFdOEhKa5UZ3waKgHaKZ?w=115&h=180&c=7&r=0&o=7&cb=defcache2&dpr=1.5&pid=1.7&rm=3&defcache=1" },
  { id: 16, name: "Smoked Vanille", price: 205, category: "Gourmand", notes: ["smoke", "vanille", "woods"], img: "https://th.bing.com/th/id/OIP.D_Jw2_cVTppmL7f8pk4cdQHaHa?w=171&h=180&c=7&r=0&o=7&cb=defcache2&dpr=1.5&pid=1.7&rm=3&defcache=1" },
  { id: 17, name: "Royal Rose", price: 250, category: "Floral", notes: ["rose", "oud", "patchouli"], img: "https://th.bing.com/th/id/OIP.sxmhhv2pxInSskpzxfJtDAHaHa?w=171&h=180&c=7&r=0&o=7&cb=defcache2&dpr=1.5&pid=1.7&rm=3&defcache=1" },
  { id: 18, name: "Citrus Grove", price: 145, category: "Citrus", notes: ["bergamote", "orange", "basil"], img: "https://th.bing.com/th/id/OIP.HOMydqGm1F0i2ZBEjNzmMAHaJQ?w=143&h=180&c=7&r=0&o=7&cb=defcache2&dpr=1.5&pid=1.7&rm=3&defcache=1" },
  { id: 19, name: "Vetiver Rain", price: 170, category: "Woody", notes: ["vetiver", "moss", "cedar"], img: "https://tse1.mm.bing.net/th/id/OIP.HIekFEkQ1fiYz16n9zV6TwHaHa?cb=defcache2&pid=ImgDet&defcache=1&w=181&h=181&c=7&dpr=1.5&o=7&rm=3" },
  { id: 20, name: "Spiced Honey", price: 195, category: "Gourmand", notes: ["honey", "cinnamon", "amber"], img: "https://tse1.mm.bing.net/th/id/OIP.quEISlAX_cAm6-FkupC-ZQHaHa?cb=defcache2&pid=ImgDet&defcache=1&w=178&h=178&c=7&dpr=1.5&o=7&rm=3" },
  { id: 21, name: "Lavender Haze", price: 165, category: "Floral", notes: ["lavender", "vanille", "musc"], img: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/CaramelizedLavanderandHazelnut.jpg?v=1712929016&width=1400&height=1400&crop=center" },
  { id: 22, name: "Dark Chocolate", price: 200, category: "Gourmand", notes: ["cocoa", "tonka bean", "vanille"], img: "https://zaoud.it/cdn/shop/files/chocola-addict-perfume-bottle-surrounded-with-orange-and-chocolate-against-white-background.jpg?v=1741005149&width=1445" },
  { id: 23, name: "Green Tea", price: 150, category: "Fresh", notes: ["green tea", "lemon", "jasmine"], img: "https://tse2.mm.bing.net/th/id/OIP.v3Qj_LKyJDn3SxC8R4GF3wHaI4?cb=defcache2&pid=ImgDet&defcache=1&w=178&h=213&c=7&dpr=1.5&o=7&rm=3" },
  { id: 24, name: "Mystic Incense", price: 240, category: "Oriental", notes: ["incense", "myrrh", "sandalwood"], img: "https://img.perfume.com/images/products/parent/medium/82130w.jpg" },
  { id: 25, name: "Pure Cotton", price: 160, category: "Clean", notes: ["musc", "cotton", "iris"], img: "https://th.bing.com/th/id/R.6325cce074752b9fa0e6ae176656a6e1?rik=ZQFEA7AkQ06dQg&pid=ImgRaw&r=0" },
  { id: 26, name: "Peach Nectar", price: 155, category: "Fruity", notes: ["peach", "vanille", "white tea"], img: "https://i.etsystatic.com/35834335/r/il/e5e989/5222959343/il_300x300.5222959343_sjxm.jpg" },
  { id: 27, name: "Leather & Smoke", price: 210, category: "Exotic", notes: ["leather", "smoke", "tobacco"], img: "https://kannaujheaven.com/cdn/shop/files/SmokeLeather.png?v=1705749827&width=1070" },
  { id: 28, name: "Aqua Marine", price: 165, category: "Fresh", notes: ["sea salt", "bergamote", "musc"], img: "https://cdn.media.amplience.net/i/xcite/654604-01?img404=default&w=2048&qlt=75&fmt=auto" },
  { id: 29, name: "Rose Oud Intense", price: 260, category: "Luxury", notes: ["rose", "oud", "amber"], img: "https://cdn.50-ml.com/media/catalog/product/f/r/fragrance_du_bois_oud_rose_intense_extrait_de_parfum_1.jpg?optimize=medium&bg-color=255" },
  { id: 30, name: "Sunny Fig", price: 140, category: "Fruity", notes: ["fig", "green tea", "cedar"], img: "https://sokilondon.com/wp-content/uploads/2022/10/Ellis-Brooklyn-Sun-Fruit.jpg" },
  { id: 31, name: "Midnight Musk", price: 180, category: "Clean", notes: ["musc", "lavender", "tonka bean"], img: "https://fimgs.net/mdimg/perfume/375x500.84333.jpg" },
  { id: 32, name: "Spicy Amber", price: 195, category: "Oriental", notes: ["amber", "cinnamon", "patchouli"], img: "https://smileeurope.co.uk/cdn/shop/files/Spicy-Amber-Unisex-100ml-Eau-De-Parfum-French-Avenue-By-Fragrance-World-French-Avenue-32043631.jpg?v=1728561099" },
  { id: 33, name: "Citrus Basil", price: 150, category: "Citrus", notes: ["lemon", "basil", "mint"], img: "https://i.etsystatic.com/6877294/r/il/af79f6/5616878276/il_1080xN.5616878276_bf7m.jpg" },
  { id: 34, name: "Velvet Iris", price: 205, category: "Powdery", notes: ["iris", "musc", "vanille"], img: "https://noah.com.au/cdn/shop/files/essentialparfums_velvetiris_mood_2.jpg?v=1750387577&width=1500" },
  { id: 35, name: "Coconut Breeze", price: 170, category: "Gourmand", notes: ["coconut", "vanille", "lime"], img: "https://tse4.mm.bing.net/th/id/OIP.jqnsNv7iS9bhgUtUlGjs5wHaHa?cb=defcache2&defcache=1&rs=1&pid=ImgDetMain&o=7&rm=3" },
  { id: 36, name: "Sandalwood Calm", price: 190, category: "Woody", notes: ["sandalwood", "musc", "cardamom"], img: "https://africologyspa.com/cdn/shop/products/Sandalwood_Perfume.jpg?v=1645104386" },
  { id: 37, name: "Cherry Blossom", price: 160, category: "Floral", notes: ["peony", "rose", "white tea"], img: "https://fimgs.net/mdimg/perfume/375x500.60119.jpg" },
  { id: 38, name: "Black Pepper", price: 185, category: "Spicy", notes: ["black pepper", "cedar", "vetiver"], img: "https://havnstore.com/cdn/shop/files/cdgparfumsblackpepper2.jpg?v=1695088428&width=1365" },
  { id: 39, name: "Neroli Port", price: 215, category: "Fresh", notes: ["neroli", "lemon", "amber"], img: "https://perfumescardales.com.ar/wp-content/uploads/2023/09/porto-neroli1.jpg" },
  { id: 40, name: "Tobacco Vanille", price: 245, category: "Gourmand", notes: ["tobacco", "vanille", "cacao"], img: "https://perfume-malaysia.com/wp-content/uploads/2013/09/tobacco-vanille-50ml.jpg" },
  { id: 41, name: "Suede & Velvet", price: 200, category: "Exotic", notes: ["suede", "musc", "iris"], img: "https://habibiny.com/cdn/shop/products/image00004_dcc3531c-6055-4724-b6a0-05297a36e120.jpg?v=1712036164" },
  { id: 42, name: "Grapefruit Gin", price: 155, category: "Citrus", notes: ["grapefruit", "juniper", "lime"], img: "https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Ginger-_-Grapefruit-Zing---The-Wellness-Collection_4ac2535f-f54d-4da0-a578-b3257c0053a4.png?v=1712932638&width=1800&height=1800&crop=center" },
  { id: 43, name: "Patchouli Earth", price: 175, category: "Woody", notes: ["patchouli", "moss", "musc"], img: "https://microless.com/cdn/products/8d488beaa5ac87224b4d5dd762e7c45d-hi.jpg" },
  { id: 44, name: "Caramel Santal", price: 195, category: "Gourmand", notes: ["caramel", "sandalwood", "salt"], img: "https://fimgs.net/mdimg/perfume/social.116122.jpg" },
  { id: 45, name: "Gardenia Rain", price: 220, category: "Floral", notes: ["gardenia", "rain", "musc"], img: "https://b1295301.smushcdn.com/1295301/wp-content/uploads/2020/09/gardenia-by-elizabeth-taylor-1024x1024.jpg?lossy=1&strip=1&webp=1" },
  { id: 46, name: "Blue Agave", price: 165, category: "Fresh", notes: ["agave", "sea salt", "lime"], img: "https://d2j6dbq0eux0bg.cloudfront.net/images/108958917/4584923255.jpg" },
  { id: 47, name: "Golden Myrrh", price: 235, category: "Oriental", notes: ["myrrh", "amber", "vanille"], img: "https://www.myperfumeshop.qa/cdn/shop/files/carolina-herrera-gold-myrrh-absolute-edp-perfume-cologne-673838.webp?v=1725409405&width=1000" },
  { id: 48, name: "Violet Woods", price: 180, category: "Powdery", notes: ["violet", "cedar", "iris"], img: "https://thegreenjunglebeautyshop.com/cdn/shop/files/lvnea-perfume-violet-woods-parfum-botanique-violet-orris-root-soft-woods-the-green-jungle-beauty-shop.jpg?v=1692362283" },
  { id: 49, name: "Espresso Noir", price: 190, category: "Gourmand", notes: ["coffee", "chocolate", "vanille"], img: "https://www.perfumedirect.com/cdn/shop/files/mancera-women-s-perfume-mancera-musky-garden-eau-de-parfum-women-s-perfume-120ml-120ml-39695450931359.png?v=1717604206" },
  { id: 50, name: "Island Water", price: 255, category: "Luxury", notes: ["coconut", "lime", "rum"], img: "https://tse1.mm.bing.net/th/id/OIP._-7JF_85dKKvuJbop93rxAHaJ3?cb=defcache2&defcache=1&rs=1&pid=ImgDetMain&o=7&rm=3" },
];

const ALL_NOTES = [...new Set(PERFUMES.flatMap(p => p.notes))].sort();

function App() {
  const [scrolled, setScrolled] = useState(false);
  const [activeNotes, setActiveNotes] = useState([]);
  const [activeFilter, setActiveFilter] = useState("All");
  const [cart, setCart] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [showCart, setShowCart] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedPerfume, setSelectedPerfume] = useState(null);
  const [notification, setNotification] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);

      const reveals = document.querySelectorAll('.reveal');
      reveals.forEach(reveal => {
        const windowHeight = window.innerHeight;
        const revealTop = reveal.getBoundingClientRect().top;
        const revealPoint = 100;
        if (revealTop < windowHeight - revealPoint) {
          reveal.classList.add('active');
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const filteredPerfumes = useMemo(() => {
    return PERFUMES.filter(p => {
      const matchNotes = activeNotes.length === 0 || activeNotes.every(note => p.notes.includes(note));
      const matchCategory = activeFilter === "All" || p.category === activeFilter;
      const matchSearch = p.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        p.notes.some(n => n.toLowerCase().includes(searchQuery.toLowerCase()));
      return matchNotes && matchCategory && matchSearch;
    });
  }, [activeNotes, activeFilter, searchQuery]);

  const toggleNote = (note) => {
    setActiveNotes(prev =>
      prev.includes(note) ? prev.filter(n => n !== note) : [...prev, note]
    );
  };

  const addToCart = (perfume) => {
    setCart(prev => [...prev, perfume]);
    showNotification(`${perfume.name} added to your collection`);
  };

  const removeFromCart = (index) => {
    setCart(prev => prev.filter((_, i) => i !== index));
  };

  const handleCheckout = () => {
    if (cart.length === 0) return;

    const phoneNumber = "212624784965"; // Morocco code (+212)
    let message = "Salam, I would like to order these fragrances from Aura Luxe:\n\n";

    cart.forEach(item => {
      message += `▪️ ${item.name} - $${item.price}\n`;
    });

    const total = cart.reduce((sum, item) => sum + item.price, 0);
    message += `\n💰 *Total Amount: $${total}*`;

    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  const showNotification = (msg) => {
    setNotification(msg);
    setTimeout(() => setNotification(null), 3000);
  };

  const categories = ["All", ...new Set(PERFUMES.map(p => p.category))];

  return (
    <div className="App">
      {/* Toast Notification */}
      {notification && (
        <div className="toast-notification">
          ✓ {notification}
        </div>
      )}

      {/* Cart Sidebar */}
      <div className={`cart-sidebar-backdrop ${showCart ? 'open' : ''}`} onClick={() => setShowCart(false)}>
        <div className={`cart-sidebar ${showCart ? 'open' : ''}`} onClick={e => e.stopPropagation()}>
          <div className="cart-header">
            <h3>Your Collection ({cart.length})</h3>
            <button className="close-cart" onClick={() => setShowCart(false)}>✕</button>
          </div>

          <div className="cart-items">
            {cart.length === 0 ? (
              <div className="empty-cart">
                <p>Your collection is empty.</p>
                <button className="btn-text" onClick={() => setShowCart(false)}>Start Exploring</button>
              </div>
            ) : (
              cart.map((item, index) => (
                <div key={index} className="cart-item">
                  <div className="cart-item-img">
                    <img src={item.img} alt={item.name} />
                  </div>
                  <div className="cart-item-info">
                    <h4>{item.name}</h4>
                    <p>${item.price}.00</p>
                  </div>
                  <button className="remove-item" onClick={() => removeFromCart(index)}>✕</button>
                </div>
              ))
            )}
          </div>

          <div className="cart-footer">
            <div className="cart-total">
              <span>Total</span>
              <span>${cart.reduce((total, item) => total + item.price, 0)}.00</span>
            </div>
            <button className="btn-luxury btn-checkout" disabled={cart.length === 0} onClick={handleCheckout}>
              Checkout via WhatsApp
            </button>
          </div>
        </div>
      </div>

      {/* Quick Look Modal */}
      {selectedPerfume && (
        <div className="modal-backdrop" onClick={() => setSelectedPerfume(null)}>
          <div className="quick-look-modal" onClick={e => e.stopPropagation()}>
            <button className="close-modal" onClick={() => setSelectedPerfume(null)}>✕</button>
            <div className="modal-content">
              <div className="modal-img">
                <img src={selectedPerfume.img} alt={selectedPerfume.name} />
              </div>
              <div className="modal-text">
                <h2>{selectedPerfume.name}</h2>
                <p className="modal-category">{selectedPerfume.category}</p>
                <div className="modal-notes">
                  {selectedPerfume.notes.map(n => <span key={n}>{n}</span>)}
                </div>
                <p className="modal-price">${selectedPerfume.price}.00</p>
                <p className="modal-desc">A masterpiece of olfactory art, blending rare essences for a truly unique presence.</p>
                <button className="btn-primary" onClick={() => { addToCart(selectedPerfume); setSelectedPerfume(null); }}>Add to Collection</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Navigation */}
      <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
        <div className="container nav-container">
          <div className="logo" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} style={{ cursor: 'pointer' }}>AURA LUXE</div>

          <div className="nav-controls">
            <ul className={`nav-links ${menuOpen ? 'active' : ''}`}>
              <li><a href="#home" onClick={() => setMenuOpen(false)}>Home</a></li>
              <li><a href="#discovery" onClick={() => setMenuOpen(false)}>Scent Builder</a></li>
              <li><a href="#collection" onClick={() => setMenuOpen(false)}>Collection</a></li>
              <li><a href="#about" onClick={() => setMenuOpen(false)}>Our Story</a></li>
            </ul>

            <div className="nav-actions">
              <button className="cart-btn" onClick={() => setShowCart(true)}>
                <span className="icon">🛍️</span>
                {cart.length > 0 && <span className="cart-count">{cart.length}</span>}
              </button>
              <button className="hamburger-menu" onClick={() => setMenuOpen(!menuOpen)}>
                {menuOpen ? '✕' : '☰'}
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section - 60/40 Layout */}
      <section id="home" className="hero">
        <div className="hero-overlay"></div>
        <div className="container">
          <div className="hero-grid">
            {/* Left Side - 60% Text */}
            <div className="hero-text">
              <h1 className="fade-in">Discover Your<br /><span>Signature Scent</span></h1>
              <p className="fade-in" style={{ animationDelay: '0.3s' }}>Handcrafted fragrances from the finest ingredients around the world.</p>

              <div className="hero-btns fade-in" style={{ animationDelay: '0.6s' }}>
                <a href="#collection" className="btn-luxury">Explore Collection</a>
                <a href="#discovery" className="btn-text">Build Your Scent</a>
              </div>
            </div>

            {/* Right Side - 40% Search */}
            <div className="hero-search-container fade-in" style={{ animationDelay: '0.5s' }}>
              <div className="search-box-wrapper">
                <div className="hero-search">
                  <input
                    type="text"
                    placeholder="Search by name or note..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  <button className="search-btn-hero" aria-label="Search">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="11" cy="11" r="8"></circle>
                      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                    </svg>
                  </button>
                </div>
                {searchQuery && (
                  <p className="search-hint">{filteredPerfumes.length} fragrances found</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Scent Builder / Note Picker */}
      <section id="discovery" className="discovery section-padding">
        <div className="container">
          <div className="section-header reveal">
            <h2>The Scent Builder</h2>
            <p>Select the notes that speak to your soul and discover fragrances tailored to your taste.</p>
            <div className="divider"></div>
          </div>

          <div className="note-filters reveal">
            {ALL_NOTES.map(note => (
              <button
                key={note}
                className={`note-chip ${activeNotes.includes(note) ? 'active' : ''}`}
                onClick={() => toggleNote(note)}
              >
                {note}
              </button>
            ))}
          </div>

          {activeNotes.length > 0 && (
            <div className="active-filters-info reveal">
              <p>Filtering by: <span>{activeNotes.join(' + ')}</span></p>
              <button className="clear-link" onClick={() => setActiveNotes([])}>Clear All Notes</button>
            </div>
          )}
        </div>
      </section>

      {/* Our Collection */}
      <section id="collection" className="collection section-padding bg-alt">
        <div className="container">
          <div className="section-header reveal">
            <h2>Our Collection</h2>
            <p>Each fragrance tells a story. Find yours.</p>
            <div className="divider"></div>
          </div>

          <div className="filter-bar reveal">
            <div className="category-tabs">
              {categories.map(cat => (
                <button
                  key={cat}
                  className={`tab ${activeFilter === cat ? 'active' : ''}`}
                  onClick={() => setActiveFilter(cat)}
                >
                  {cat}
                </button>
              ))}
            </div>
            <p className="item-count">{filteredPerfumes.length} Fragrances</p>
          </div>

          <div className="product-grid">
            {filteredPerfumes.map((perfume) => (
              <div key={perfume.id} className="product-card reveal">
                <div className="product-img" onClick={() => setSelectedPerfume(perfume)}>
                  <img src={perfume.img} alt={perfume.name} />
                  <div className="product-overlay">
                    <button className="btn-add" onClick={(e) => { e.stopPropagation(); addToCart(perfume); }}>Add to Cart</button>
                    <button className="btn-details" onClick={(e) => { e.stopPropagation(); setSelectedPerfume(perfume); }}>View Details</button>
                  </div>
                  <div className="category-tag">{perfume.category}</div>
                </div>
                <div className="product-info">
                  <h4>{perfume.name}</h4>
                  <div className="product-notes">
                    {perfume.notes.slice(0, 2).map(n => <span key={n}>{n}</span>)}
                    {perfume.notes.length > 2 && <span>+{perfume.notes.length - 2}</span>}
                  </div>
                  <p className="price">${perfume.price}.00</p>
                </div>
              </div>
            ))}
          </div>

          {filteredPerfumes.length === 0 && (
            <div className="no-results reveal">
              <p>No fragrances match your criteria.<br />Try adjusting your filters.</p>
              <button className="btn-luxury" onClick={() => { setActiveNotes([]); setActiveFilter("All"); setSearchQuery(""); }}>Reset All Filters</button>
            </div>
          )}
        </div>
      </section>

      {/* Our Story */}
      <section id="about" className="about section-padding">
        <div className="container about-grid">
          <div className="about-image reveal">
            <div className="img-frame">
              <img src="https://images.unsplash.com/photo-1557170334-a9632e77c6e4?auto=format&fit=crop&q=80&w=1200" alt="Perfume Making Artistry" />
            </div>
          </div>
          <div className="about-text reveal">
            <h2>Our Story</h2>
            <div className="divider" style={{ margin: '0 0 2rem 0' }}></div>
            <p>Founded in the heart of Grasse, France, Aura Luxe was born from a passion for creating unforgettable olfactory experiences. Each fragrance is a testament to our commitment to quality and artistry.</p>
            <p>We source the finest ingredients from around the world—hand-picked roses from Bulgaria, oud from Cambodia, and vanilla from Madagascar. Our master perfumers blend tradition with innovation to create scents that transcend time.</p>
            <button className="btn-outline" onClick={() => showNotification("Thank you for your interest in our story!")}>Learn More</button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-brand">
              <div className="logo">AURA LUXE</div>
              <p>Crafting timeless fragrances since 1994.</p>
              <div className="social-links">
                <span onClick={() => showNotification("Follow us on Instagram!")}>Instagram</span>
                <span onClick={() => showNotification("Like us on Facebook!")}>Facebook</span>
              </div>
            </div>
            <div className="footer-links">
              <h4>Shop</h4>
              <ul>
                <li><a href="#collection" onClick={(e) => { e.preventDefault(); showNotification("Navigating to Collection..."); }}>All Fragrances</a></li>
                <li><a href="#" onClick={(e) => { e.preventDefault(); showNotification("Gift Sets coming soon!"); }}>Gift Sets</a></li>
                <li><a href="#" onClick={(e) => { e.preventDefault(); showNotification("Limited Editions available!"); }}>Limited Editions</a></li>
              </ul>
            </div>
            <div className="footer-links">
              <h4>Experience</h4>
              <ul>
                <li><a href="#discovery" onClick={(e) => { e.preventDefault(); showNotification("Try our Scent Builder!"); }}>Scent Builder</a></li>
                <li><a href="#" onClick={(e) => { e.preventDefault(); showNotification("Book a consultation!"); }}>Consultation</a></li>
                <li><a href="#about" onClick={(e) => { e.preventDefault(); showNotification("Read our story!"); }}>Our Story</a></li>
              </ul>
            </div>
            <div className="footer-newsletter">
              <h4>Join Our Circle</h4>
              <p>Subscribe for exclusive access to new releases.</p>
              <div className="newsletter-form">
                <input type="email" placeholder="Your email address" id="newsletter-input" />
                <button className="btn-send" onClick={() => {
                  const input = document.getElementById('newsletter-input');
                  if (input.value && input.value.includes('@')) {
                    showNotification(`Success! You have subscribed with ${input.value}`);
                    input.value = "";
                  } else {
                    showNotification("Please enter a valid email address.");
                  }
                }}>Subscribe</button>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2024 Aura Luxe. All rights reserved. Crafted with passion.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
